import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonSlides, ModalController } from '@ionic/angular';
import { AuthService } from '../../../service/auth/auth.service';
import { ConfigService } from '../../../service/config/config.service';

import { NgForm } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LocaldataService } from '../../../service/localdata/localdata.service';

@Component({
  selector: 'app-precampaignsubmission',
  templateUrl: './precampaignsubmission.page.html',
  styleUrls: ['./precampaignsubmission.page.scss'],
})
export class PrecampaignsubmissionPage implements OnInit {

  @ViewChild('slides') slides: IonSlides;

  @Input() modalCtrl: ModalController;
  @Input() formobject: any;

  private appversion;
  private appplatform;
  private deviceinfo;

  private form: any;
  private factory: Factory;
  private year: string;

  private amount: number;

  private isSubmitting: boolean = false;

  constructor(private config: ConfigService, private auth: AuthService, private localData: LocaldataService, private http: HttpClient, private alertCtrl:AlertController) { }

  async submitForm(orderForm:NgForm){

    this.isSubmitting = true;

    console.log('orderForm', orderForm);

    /*if(this.amount==null){

      let alert = await this.alertCtrl.create({
        header: 'Bemærk',
        message: 'Du skal udfylde antal andele for at fortsætte.',
        buttons: ['OK'],
      });
      await alert.present();
      return;

    }*/


    if(this.form.systemname){

    var submitformdata =
      {
        "systemname": this.form.systemname,
        "displayname": this.form.displayname,
        "completed": true,
        "deadline": this.form.deadline,
        "year": this.form.year,
        "data": orderForm.value,
        "factoryId": this.form.factoryId,
        "farmerId": this.auth.userProfile.id,
        "formavailableId": this.form.id
      }
    }


    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

    const options = {
      headers: headers
    };
    


  this.http.post(this.config.basePath + '/api/forms', submitformdata, options)
    .subscribe(
      (res) => {

          if (res) {
            //if (res.status === 200) {

              if(this.form.onceperyear){
                this.form.status = 'completed';
              }

              this.localData.remoteUpdateFormsAvailable().then(() =>{
                this.isSubmitting = false;
                this.nextSlide(3,null);
              });

            //}
          }
        },
        (err) => {
          this.isSubmitting = false;
          this.submitError();

        }
      );



  }

  async submitError(){
    let alert = await this.alertCtrl.create({
      header: 'Der opstod en fejl ved indsendelse',
      message: 'Prøv igen. Hvis problemet fortsætter kontakt da venligst ' + this.factory.displayname,
      buttons: ['OK'],
    });
    await alert.present();
  }
  
  onAddOrder(orderForm:NgForm) {

  }

  completeSubmission(){
    this.closeModal();
  }
  
  closeModal() {
    return this.modalCtrl.dismiss();
  }

  async nextSlide(paramIntSlide:number, form:NgForm){

    /*let slideNumber = await this.slides.getActiveIndex();
    if(slideNumber==2 && (this.amount==null)){

      let alert = await this.alertCtrl.create({
        header: 'Bemærk',
        message: 'Du skal udfylde dit CPR-nummer for at fortsætte.',
        buttons: ['OK'],
      });
      await alert.present();
      return;

    }*/
    this.slides.slideNext();
  }


  ngOnInit() {
    this.form = this.formobject;
    console.log('log', this.formobject)
    this.factory = this.formobject.factory;
    this.year = this.formobject.year;
  }

}

export interface Factory {
  id: any;
  displayname: any;
  address: any;
}